import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';


Vue.config.productionTip = false

// 全局配置axios
Vue.prototype.$axios = axios

new Vue({
  axios,
  router,
  render: h => h(App)
}).$mount('#app')
